import carSections from 'components/Car/sections'
import orderSections from 'components/Order/sections'
import contractorSections from 'components/Contractors/sections'
import insurancePolicySections from 'components/Contractors/InsurancePolicy/sections'
import userSections from 'components/Users/sections'
import driverSections from 'components/Drivers/sections'
import ferryServiceSections from 'components/FerryServices/sections'
import Module from 'constants/customFieldModules'
import { mapToArray } from 'constants/utils'

export const mapModuleToSectionOptions = (module) => {
  const sections = getSectionsByModule(module)
  return mapToArray(sections)
}

const getSectionsByModule = (module) => {
  switch (module) {
    case Module.Orders.value:
      return orderSections
    case Module.Users.value:
      return userSections
    case Module.Drivers.value:
      return driverSections
    case Module.Cars.value:
      return carSections
    case Module.Contractors.value:
      return contractorSections
    case Module.ContractorPolicies.value:
      return insurancePolicySections
    case Module.FerryServices.value:
      return ferryServiceSections
    default:
      return []
  }
}
